import { render } from "./AgeGroupCategory.vue?vue&type=template&id=3b8dc937&scoped=true"
import script from "./AgeGroupCategory.vue?vue&type=script&lang=js"
export * from "./AgeGroupCategory.vue?vue&type=script&lang=js"

import "./AgeGroupCategory.vue?vue&type=style&index=0&id=3b8dc937&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8dc937"]])

export default __exports__